import { render, staticRenderFns } from "./PlaceForm.vue?vue&type=template&id=88347cb2&scoped=true&"
import script from "./PlaceForm.vue?vue&type=script&lang=js&"
export * from "./PlaceForm.vue?vue&type=script&lang=js&"
import style0 from "./PlaceForm.vue?vue&type=style&index=0&id=88347cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88347cb2",
  null
  
)

export default component.exports